var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boxMenu",class:{ select : _vm.isSelect },on:{"click":_vm.updateBox}},[_c('div',{staticClass:"title"},[_c('span',[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }